import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SUPPORT_SLOT } from '../../static/constants.js';

const UserFriendlyFieldWrapper = ({ children }) => {
  const [touched, setTouched] = useState(false);
  
  const handleInteraction = (event) => {
    if (!touched) setTouched(true);
    if (event.type === 'change') {
      children.props.onChange?.(event);
    }
    if (event.type === 'blur') {
      children.props.onBlur?.(event);
    }
    if (event.type === 'focus') {
      children.props.onFocus?.(event);
    }
    if (event.type === 'click') {
      children.props.onClick?.(event);
    }
  };

  const interactionProps = {
    onChange: handleInteraction,
    onBlur: handleInteraction,
    invalid: touched ? children.props.invalid : false,
    children: touched
      ? children.props.children
      : children.props.children.filter(
        (child) => !child?.props?.slot || child.props.slot !== SUPPORT_SLOT
      ),
  };

  const clonedChild = React.cloneElement(children, interactionProps);

  return <>{clonedChild}</>;
};

UserFriendlyFieldWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default UserFriendlyFieldWrapper;
